import { GetServerSidePropsContext } from 'next'

import { serverSidePropsFor } from '@/utils/helpers.server'

import CommandersPage from '../commanders'

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
  const replacedSlug = context.query.slug === 'boomerang' ? 'boomerang_' : context.query.slug // Adblock workaround
  return serverSidePropsFor(`${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/cards/${replacedSlug}.json`)
}

export default CommandersPage
